import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { AutoLoginGuard } from './guards/auto-login.guard';
import { LoginComponent } from './pages/login/login.component';
import { RegisterComponent } from './pages/register/register.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { AuthGuard } from './guards/auth.guard';
import { Roles } from './models/roles';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { VerifyComponent } from './pages/verify/verify.component';
import { DiscoverComponent } from './pages/discover/discover.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './pages/terms-of-service/terms-of-service.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { AccountTypes } from './models/account_types';

export const RESERVED_STORE_SUBPATHS = [
  'products',
  'menu',
  'cart',
  'shipping',
  'payment',
  'orders',
  'discover',
  'table',
];

const routes: Routes = [
  {
    path: '',
    redirectTo: 'discover',
    pathMatch: 'full',
  },
  {
    path: 'discover',
    component: DiscoverComponent,
    canActivate: [AutoLoginGuard],
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AutoLoginGuard],
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [AutoLoginGuard],
  },
  {
    path: 'register',
    component: RegisterComponent,
    canActivate: [AutoLoginGuard],
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
    canActivate: [AutoLoginGuard],
  },
  {
    path: 'terms-of-service',
    component: TermsOfServiceComponent,
    canActivate: [AutoLoginGuard],
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    canActivate: [AutoLoginGuard],
  },
  {
    path: 'change-password/:role/:token',
    component: ChangePasswordComponent,
    canActivate: [AutoLoginGuard],
  },
  {
    path: 'verify/:role/:token',
    component: VerifyComponent,
    canActivate: [AutoLoginGuard],
  },
  {
    path: 'not-found',
    component: NotFoundComponent,
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./pages/dashboard/main-layout/main-layout.module').then(
        (m) => m.MainLayoutModule,
      ),
    canActivate: [AuthGuard],
    data: {
      account_types: [AccountTypes.Merchant, AccountTypes.Delivery],
      roles: [Roles.Admin, Roles.Manager],
      plans: [1, 2, 3],
    },
  },
  {
    path: ':business_name/table/:table_id',
    loadChildren: () =>
      import('./pages/store/store.module').then((m) => m.StoreModule),
  },
  {
    path: ':business_name',
    loadChildren: () =>
      import('./pages/store/store.module').then((m) => m.StoreModule),
  },
  {
    path: ':business_name/:child_business_name',
    loadChildren: () =>
      import('./pages/store/store.module').then((m) => m.StoreModule),
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
